import styled from "styled-components";

export const CardsWrapper = styled.div`
  display: flex;
  gap: var(--fd-space-space-2);
  padding: var(--fd-space-space-4);
`;

export const TitleWrapper = styled.div`
  display: flex;
  padding: var(--fd-space-space-6) var(--fd-space-space-4);
  height: 100%;
  max-height: 25px;
  overflow: hidden;
  margin-bottom: var(--fd-space-space-3);
  width: 100%;
  max-width: 200px;
  background: var(--fd-colors-background-surface);
`;

export const VideoSectionWrapper = styled.div`
  width: 100%;
  background: var(--fd-colors-background-surface);
`;

export const LatestVideos = styled.div`
  background: var(--fd-colors-background-surface);
  border-bottom: 1px solid var(--fd-colors-border-subtle);
  display: flex;
  gap: var(--fd-space-space-2);
  padding: var(--fd-space-space-4);
`;
